import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  bypassAddressValidation: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: AppConfig = { bypassAddressValidation: false };

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    try {
      this.config = await firstValueFrom(
        this.http.get<AppConfig>('/assets/config/app-config.json')
      );
    } catch (err) {
      console.error('Failed to load app-config.json, using defaults', err);
    }
  }

  get bypassAddressValidation(): boolean {
    return this.config.bypassAddressValidation;
  }
}